<template>
  <section id="about">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="dasboard-content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="tittle">
              <h3>Privacy Policy</h3>
            </div>
            <div class="content">
              <p>This website is operated by the owner of the website. We take your privacy very seriously therefore we urge to read this policy very carefully because it contains important information about on:</p>
              <ul>
                <li><p class="mb-0">Who we are,</p></li>
                <li><p class="mb-0">How and why we collect, store, use and share personal information</p></li>
                <li><p class="mb-0">Your rights in relation to your personal information, and</p></li>
                <li><p class="mb-0">How to contact us and supervisory authorities in the event that you have a complaint</p></li>
              </ul>
            </div>
            <div class="content">
              <h5 class="content-heading">Who we are</h5>
              <p>The website owner ('we' or 'us') (trading as Fintransformer) collects, uses and is responsible for certain personal information about you. When we do so we are responsible as 'controller' of that personal information for the purposes of applicable laws.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">The personal information we collect and use</h5>
              <h6 class="definition-heading">a) Personal information you provide to us</h6>
              <p>We collect the following personal information that you provide to us:</p>
              <ul style="">
                <li><p class="mb-0">First name</p></li>
                <li><p class="mb-0">Last name</p></li>
                <li><p class="mb-0">Email address</p></li>
                <li><p class="mb-0">Telephone number</p></li>
                <li><p class="mb-0">Job title or Function</p></li>
                <li><p class="mb-0">Employer's (company) name</p></li>
                <li><p class="mb-0">Employer's (company) address</p></li>
                <li><p class="mb-0">Employer's (company) website</p></li>
              </ul>
              <p>Some examples of when we collect this information include:</p>
              <p>When registering for an account</p>
              <h6 class="definition-heading">b) Personal information from other source</h6>
              <p>We may receive information about you from other sources. This information includes:</p>
              <ul style="">
                <li><p class="mb-0">Company data</p></li>
                <li><p class="mb-0">Business information</p></li>
                <li><p class="mb-0">Trade references</p></li>
                <li><p class="mb-0">Credit ratings</p></li>
              </ul>
              <p>We will add this information to the information we hold about you for the following purposes:</p>
              <ul style="">
                <li><p class="mb-0">To check creditworthiness</p></li>
                <li><p class="mb-0">To check for possible fraudulent activity</p></li>
                <li><p class="mb-0">To confirm information entered by the user</p></li>
                <li><p class="mb-0">To improve and personalise our service</p></li>
              </ul>
              <h6 class="definition-heading">c) Personal information you provide about third parties</h6>
              <p>If you give us information about another person, you confirm that the other person has appointed you to act on their behalf and agreed that you:</p>
              <ul style="">
                <li><p class="mb-0">Shall consent on their behalf to the processing of their personal data</p></li>
                <li><p class="mb-0">Shall receive any data protection notices on their behalf and</p></li>
                <li><p class="mb-0">Shall consent on their behalf to the transfer of their personal data abroad.</p></li>
              </ul>
              <h6 class="definition-heading">d) Monitoring and recording communications</h6>
              <p>We may monitor communications such as emails and telephone calls for the following purposes:</p>
              <ul style="">
                <li><p class="mb-0">Quality assurance</p></li>
                <li><p class="mb-0">Training</p></li>
                <li><p class="mb-0">Fraud prevention</p></li>
                <li><p class="mb-0">Dispute resolution</p></li>
                <li><p class="mb-0">Process improvement</p></li>
                <li><p class="mb-0">Product enhancement</p></li>
                <li><p class="mb-0">Compliance</p></li>
              </ul>
              <h6 class="definition-heading">e) Cookies and similar technologies</h6>
              <p>A cookie is a small text file which is placed onto your computer or electronic device when you access our website. Similar technologies include web beacons, action tags, local shared objects ('flash cookies') and single-pixel gifs. Such technologies can be used to track users' actions and activities, and to store information about them. We use these cookies and/or similar technologies on this website.</p>
              <p>For example we may use cookies to monitor and/or collect the following information:</p>
              <ul style="">
                <li><p class="mb-0">How many times a user visits the website</p></li>
                <li><p class="mb-0">Which pages a user visits</p></li>
                <li><p class="mb-0">Traffic data</p></li>
                <li><p class="mb-0">Location data</p></li>
              </ul>
              <p>This information helps us to build a profile of our users. Some of this information may be aggregated or statistical, which means that we will not be able to identify you individually.</p>
              <p>In addition it should be noted that in some cases our cookies or similar technologies may be owned and controlled by third parties who will also collect personal information about you.</p>
              <p>On the first occasion that you use our site we will ask whether you consent to our use of cookies. If you do not, cookies will not be used. Thereafter you can opt-out of using cookies at any time or you can set your browser not to accept cookies and the websites below tell you how to remove cookies from your browser. However, some of our website features may not function as a result.</p>
              <p>For further information on our use of cookies, please see our Website cookie policy.</p>
              <p>For further information on cookies generally visit www.aboutcookies.org or www.allaboutcookies.org.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">How we use your personal information</h5>
              <p>We collect information about our users for the following purposes:</p>
              <ul style="">
                <li><p class="mb-0">Identify you and manage any accounts you hold with us</p></li>
                <li><p class="mb-0">Process your order</p></li>
                <li><p class="mb-0">Conduct research, statistical analysis and behavioural analysis</p></li>
                <li><p class="mb-0">Carry out customer profiling and analyse your purchasing preferences</p></li>
              </ul>
            </div>
            <div class="content">
              <h5 class="content-heading">Who your information may be shared with</h5>
              <p>We may share your information with:</p>
              <ul style="">
                <li><p class="mb-0">Law enforcement agencies in connection with any investigation to help prevent unlawful activity</p></li>
                <li><p class="mb-0">Parent company and parties related by common ownership</p></li>
                <li><p class="mb-0">Partnering financial institutions</p></li>
                <li><p class="mb-0">Partnering financial services brokers</p></li>
              </ul>
              <p>We will not share your personal information with any other 3rd parties.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">Marketing</h5>
              <p>We would like to send you information about products, services, offers, competitions and our business which may be of interest to you. Such information could be sent by post, email, telephone, text message or automated call.</p>
              <p>We will ask whether you would like us to send you marketing messages on the first occasion that you provide any relevant contact information (i.e. on purchase, signing up to a newsletter, entering a competition etc). If you do opt in to receive such marketing from us you can opt out at any time (see 'What rights do you have?' below for further information). If you have any queries about how to opt out, or if you are receiving messages you do not want you can contact us using the details provided below.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">Whether personal information has to be provided by you, and if so why</h5>
              <p>The provision of the following information is required from you:</p>
              <ul style="">
                <li><p class="mb-0">First and last name</p></li>
                <li><p class="mb-0">Email address</p></li>
              </ul>
              <p>This is to enable us to do the following:</p>
              <ul style="">
                <li><p class="mb-0">To authenticate user</p></li>
                <li><p class="mb-0">To provide receipt of purchase</p></li>
              </ul>
              <p>We will inform you at the point of collecting information from you, whether you are required to provide the information to us.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">How long your personal information will be kept</h5>
              <p>We will hold your personal information for the following periods:</p>
              <ul style="">
                <li><p class="mb-0">Up to 7 years</p></li>
              </ul>
              <p>These periods are no longer than necessary in each case.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">Reasons we can collect and use your personal information</h5>
              <p>We rely on the following as the lawful basis on which we collect and use your personal information:</p>
              <ul style="">
              <li><p class="mb-0">Consent</p></li>
              <li><p class="mb-0">Contract</p></li>
              </ul>
            </div>
            <div class="content">
              <h5 class="content-heading">Keeping your information secure</h5>
              <p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. We limit access to your personal information to those who have a genuine business need to know it. Those processing your information will do so only in an authorised manner and are subject to a duty of confidentiality.</p>
              <p>We will also use technological and organisation measures to keep your information secure.</p>
              <p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p>
              <p>Indeed, while we will use all reasonable efforts to secure your personal data, in using the site you acknowledge that the use of the internet is not entirely secure and for this reason we cannot guarantee the security or integrity of any personal data that are transferred from you or to you via the internet. If you have any particular concerns about your information, please contact us using the details below.</p>
            </div>
            <div class="content">
              <h5 class="content-heading">Transfers of your information</h5>
              <p>We may need to transfer your personal data to other countries.</p>
              <p>These transfers will be undertaken for the purpose of data storage and processing.</p>
              <p>Any transfers to these countries will be undertaken on the basis that that country, territory or one or more specific sectors in that country, ensures an adequate level of protection.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created () {
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>

.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy.vue